import React from 'react';
import { Select } from 'antd';
import type { SelectProps } from 'antd';

const SizeChangerSelect = (props: SelectProps) => (
    <Select {...props} showSearch={false} size="small" />
);

SizeChangerSelect.Option = Select.Option;

export default SizeChangerSelect;
